._button_17b8c_1 {
  border: 1px solid #d6e6fe !important;
  box-shadow: 0px 6px 24px 0px rgba(0, 6, 36, 0.0784314) !important; }
  ._buttonDark_17b8c_4 {
    border: 1px solid #717274 !important;
    background: #515254 !important; }
